import { useAuthStore, type AuthState } from '@/stores/auth-store';

export function useAuth(): AuthState {
  return useAuthStore();
}
